// @notes pointer-events seemingly work unreliably directly on svg's so i'm wrapping the icon in a span
import React, {FC} from "react"
import id from "@irati/utils/id"
import {OverlayProps, OverlayPlacement} from "./Overlay"
import {IconWrapper} from "./styled"
import {Tooltip} from "./"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

export interface IconTooltipProps extends Omit<OverlayProps, "theme"> {
  size?: number
  icon?: string
  className?: IconTypes
  placement?: OverlayPlacement
}

const IconTooltip: FC<IconTooltipProps> = ({
  children,
  placement = OverlayPlacement.Right,
  size = 16,
  icon = IconTypes.information,
  className,
  ...props
}) => {
  const idNamespace = id("IconTooltip", props)

  return (
    <Tooltip id={idNamespace} placement={placement} tooltipChildren={children}>
      <IconWrapper size={size} className={className}>
        <Icon icon={icon} size={size} {...props} />
      </IconWrapper>
    </Tooltip>
  )
}

export default IconTooltip
